import { useCallback } from "react";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import {
  AppLayoutContext,
  appSelectionItemKey,
  type AppSelectionItem,
} from "@-/dev.improve.haniverse.routes.nav.app._context";
import { useAppSelectionActions } from "#use-app-selection-actions";
import { isNonEmpty } from "@-/com.npmjs.ts-array-length";

/** Connects one domain button (or one grouped button) to app-wide selection mode. */
export function useAppSelection(items: readonly AppSelectionItem[]) {
  const [isSelecting, isSelected] = useContextSelectors(
    AppLayoutContext,
    (c) => c.isSelecting,
    (c) =>
      isNonEmpty(items) && items.every((item) => c.selectedItems.has(appSelectionItemKey(item))),
  );
  const { startSelecting, toggleSelected } = useAppSelectionActions();

  const onLongPress = useCallback(() => {
    startSelecting(items);
  }, [items, startSelecting]);

  const consumePress = useCallback(() => {
    if (!isSelecting) {
      return false;
    }
    toggleSelected(items);
    return true;
  }, [isSelecting, items, toggleSelected]);

  return { consumePress, isSelected, isSelecting, onLongPress };
}
